import type { Job } from '@/types';

export const jobs: Job[] = [
  {
    id: 'JOB-2026-0516',
    customerName: 'Emre Korkmaz',
    phone: '0544 567 29 18',
    service: 'Plaza / Ofis Temizliği',
    location: 'Şişli / İstanbul',
    address: 'Şişli, Nişantaşı No:9',
    team: 'C Ekibi',
    date: '26 Ağustos 2026',
    time: '08:30',
    status: 'İş Devam Ediyor',
    scope: 'İlk ofis temizliği, açık ofis alanı ve toplantı odaları.',
    jobValue: 5500,
    quoteId: '',
    timeline: [
      { time: '08:15', text: 'Adrese varıldı' },
      { time: '08:30', text: 'İş başladı' },
      { time: '09:05', text: 'İş devam ediyor' },
    ],
    notes: ['Müşteri ilk deneme için memnuniyet bekliyor.'],
  },
  {
    id: 'JOB-2026-0512',
    customerName: 'Ayşe Yılmaz',
    phone: '0532 456 78 90',
    service: 'Villa Detaylı Temizlik',
    location: 'Beykoz / İstanbul',
    address: 'Beykoz, Kavacık Mah. No:12',
    team: 'A Ekibi',
    date: '26 Ağustos 2026',
    time: '10:00',
    status: 'Yola Çıkılacak',
    scope: '2 katlı villa detaylı temizlik, camlar, zemin cilası, mutfak-banyo derin temizliği.',
    jobValue: 18500,
    quoteId: 'VP-2026-0048',
    timeline: [
      { time: '08:30', text: 'Ekip hazırlığı tamamlandı' },
      { time: '09:45', text: 'Ekipmanlar yüklendi' },
      { time: '09:50', text: 'Yola çıkılmak üzere' },
    ],
    notes: ['Üst kattaki camlar için ilave çalışma gerekiyor.'],
  },
  {
    id: 'JOB-2026-0513',
    customerName: 'Elif Doğan',
    phone: '0537 450 88 26',
    service: 'Villa Temizliği',
    location: 'Üsküdar / İstanbul',
    address: 'Üsküdar, Kuzguncuk No:7',
    team: 'B Ekibi',
    date: '26 Ağustos 2026',
    time: '13:30',
    status: 'Planlandı',
    scope: 'Villa dönemsel derin temizlik.',
    jobValue: 15000,
    quoteId: 'VP-2026-0046',
    timeline: [{ time: '13:00', text: 'İş planlandı' }],
    notes: [],
  },
  {
    id: 'JOB-2026-0514',
    customerName: 'Mehmet Demir',
    phone: '0533 214 55 87',
    service: 'İnşaat Sonrası Temizlik',
    location: 'Silivri / İstanbul',
    address: 'Silivri, Selimpaşa Cad. No:88',
    team: 'A Ekibi',
    date: '26 Ağustos 2026',
    time: '16:00',
    status: 'Planlandı',
    scope: 'İnşaat sonrası ilk temizlik, moloz ve ince toz temizliği.',
    jobValue: 0,
    quoteId: '',
    timeline: [{ time: '16:00', text: 'İş planlandı' }],
    notes: ['Teklif öncesi metrekare teyidi gerekli.'],
  },
  {
    id: 'JOB-2026-0515',
    customerName: 'Ahmet Çelik',
    phone: '0535 321 90 44',
    service: 'Plaza / Ofis Temizliği',
    location: 'Kadıköy / İstanbul',
    address: 'Kadıköy, Moda Cad. No:21',
    team: 'C Ekibi',
    date: '27 Ağustos 2026',
    time: '09:00',
    status: 'Planlandı',
    scope: 'Aylık ofis temizliği.',
    jobValue: 8500,
    quoteId: 'VP-2026-0043',
    timeline: [{ time: '09:00', text: 'İş planlandı' }],
    notes: [],
  },
  {
    id: 'JOB-2026-0487',
    customerName: 'Ayşe Yılmaz',
    phone: '0532 456 78 90',
    service: 'Villa Detaylı Temizlik',
    location: 'Beykoz / İstanbul',
    address: 'Beykoz, Kavacık Mah. No:12',
    team: 'A Ekibi',
    date: '20 Ağustos 2026',
    time: '10:00',
    status: 'Kapandı',
    scope: 'Villa dönemsel derin temizlik, tüm katlar ve camlar.',
    jobValue: 16000,
    quoteId: 'VP-2026-0041',
    timeline: [
      { time: '09:45', text: 'Yola çıkıldı' },
      { time: '10:00', text: 'İş başladı' },
      { time: '15:20', text: 'İş tamamlandı' },
      { time: '15:40', text: 'Müşteri kontrolü yapıldı' },
      { time: '16:00', text: 'Kapandı' },
    ],
    notes: [],
  },
  {
    id: 'JOB-2026-0491',
    customerName: 'Murat Öztürk',
    phone: '0541 902 67 31',
    service: 'Koltuk Yıkama',
    location: 'Çankaya / Ankara',
    address: 'Ankara, Çankaya No:19',
    team: 'B Ekibi',
    date: '22 Ağustos 2026',
    time: '14:00',
    status: 'Kapandı',
    scope: '3+2 koltuk takımı yıkama.',
    jobValue: 7800,
    quoteId: 'VP-2026-0045',
    timeline: [
      { time: '13:50', text: 'Adrese varıldı' },
      { time: '14:00', text: 'İş başladı' },
      { time: '17:00', text: 'İş tamamlandı' },
      { time: '17:15', text: 'Kapandı' },
    ],
    notes: [],
  },
  {
    id: 'JOB-2026-0493',
    customerName: 'Fatma Şahin',
    phone: '0539 876 40 93',
    service: 'Yazlık Ev Temizliği',
    location: 'Büyükçekmece / İstanbul',
    address: 'Büyükçekmece, Mimar Sinan No:2',
    team: 'C Ekibi',
    date: '23 Ağustos 2026',
    time: '09:00',
    status: 'Kapandı',
    scope: 'Yazlık açılış temizliği, tüm alanlar.',
    jobValue: 9600,
    quoteId: 'VP-2026-0044',
    timeline: [
      { time: '08:50', text: 'Adrese varıldı' },
      { time: '09:00', text: 'İş başladı' },
      { time: '13:10', text: 'İş tamamlandı' },
      { time: '13:30', text: 'Kapandı' },
    ],
    notes: ['Kalan bakiyenin tahsil edilmesi bekleniyor.'],
  },
  {
    id: 'JOB-2026-0495',
    customerName: 'Can Aksoy',
    phone: '0538 123 74 58',
    service: 'Residence Temizliği',
    location: 'Beşiktaş / İstanbul',
    address: 'Beşiktaş, Levent No:44',
    team: 'A Ekibi',
    date: '19 Ağustos 2026',
    time: '11:00',
    status: 'Kapandı',
    scope: 'Rezidans daire detaylı temizlik.',
    jobValue: 6500,
    quoteId: 'VP-2026-0040',
    timeline: [
      { time: '10:50', text: 'Adrese varıldı' },
      { time: '11:00', text: 'İş başladı' },
      { time: '14:00', text: 'İş tamamlandı' },
      { time: '14:10', text: 'Kapandı' },
    ],
    notes: [],
  },
];